export default __webpack_public_path__ + "media/src/images/assign_route/circle-4e828135935ec0cf0bfacaeedc21fcc7.svg";